import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import Hero from '../../components/Hero';
import TreatmentSelector from '../../components/TreatmentSelector';
import Source from '../../components/Source';
import Footnotes from '../../components/Footnotes';
import Footer from '../../components/Footer';

import { setEnvironment } from '../../actions/environment';
import { setOption, clearOption } from '../../actions/options';

class Home extends Component {
  constructor (props) {
    super(props);
    const { dispatch } = props;
    this.boundActionCreators = bindActionCreators({
      setEnvironment,
      setOption,
      clearOption,
    }, dispatch);
  }

  componentDidMount () {
    const { dispatch } = this.props;
    dispatch(clearOption());
  }

  setEnvironment (env) {
    const { dispatch } = this.props;
    dispatch(clearOption());
    dispatch(setEnvironment(env));
  }

  setOption (optionSelected) {
    const { dispatch } = this.props;
    dispatch(setOption(optionSelected));
  }

  render () {
    return (
      <div className="home">
        <Hero />
        <TreatmentSelector setOption={ optionSelected => this.setOption(optionSelected) } />
        <Source
          setOption={ optionSelected => this.setOption(optionSelected) }
          optionSelected={ this.props.optionSelected }
        />
        <Footnotes footnotes={ [1, 2, 3, 4] } customClass="homeFootNote"/>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  optionSelected: state.options.source,
});

export default withRouter(connect(mapStateToProps)(Home));
